import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import AssignmentLateOutlinedIcon from '@mui/icons-material/AssignmentLateOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { Box, Divider, Link } from '@mui/material';
import React from 'react';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { convertMillisecondsToHours } from '../../../../ui/utils/convertMillisecondsToHours';
import { MissionDetails } from './MissionDetails';
export const MissionDetailsAdmin = ({ missionId, missionName, missionType, missionStatus, missionPlaceholdersDetails, hasActiveShifts, onAddShift, onMissionClose, descriptionId, detailsDescriptionId, }) => {
    const { t } = useMissionsTranslation();
    const isMissionClosed = missionStatus === 'closed';
    const { totalShifts, openSlots, pendingRequests, totalVolunteers, totalHours } = missionPlaceholdersDetails;
    let placeHolders;
    if (!isMissionClosed) {
        placeHolders = [
            {
                icon: React.createElement(AssignmentOutlinedIcon, null),
                title: t('missions.totalShifts'),
                value: totalShifts,
            },
            {
                icon: React.createElement(AssignmentIndOutlinedIcon, null),
                title: t('missions.openSlots'),
                value: openSlots,
            },
            {
                icon: React.createElement(AssignmentLateOutlinedIcon, null),
                title: t('missions.pendingRequests'),
                value: pendingRequests,
            },
        ];
    }
    else {
        placeHolders = [
            {
                icon: React.createElement(SupervisorAccountOutlinedIcon, null),
                title: t('missions.totalVolunteers'),
                value: totalVolunteers,
            },
            {
                icon: React.createElement(TimerOutlinedIcon, null),
                title: t('missions.totalHours'),
                value: convertMillisecondsToHours(totalHours),
            },
        ];
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(MissionDetails, { missionId: missionId, missionName: missionName, missionType: missionType, missionStatus: missionStatus, placeHolders: placeHolders, descriptionId: descriptionId, detailsDescriptionId: detailsDescriptionId }),
        !isMissionClosed && (React.createElement(React.Fragment, null,
            React.createElement(Divider, { sx: { mx: 2 } }),
            !hasActiveShifts && (React.createElement(Box, { p: 2, sx: { typography: 'body2', textAlign: { xs: 'left', sm: 'center' }, pt: 2 } },
                `${t('missions.noUpcomingShiftsForMission')}. `,
                React.createElement(Box, { sx: { display: { sm: 'inline-block' } } },
                    React.createElement(Link, { component: 'button', typography: 'button', onClick: onAddShift, "data-test": 'add-new-shift-button' }, t('missions.addShift')),
                    ` ${t('missions.or')} `,
                    React.createElement(Link, { component: 'button', typography: 'button', onClick: onMissionClose, "data-test": 'mission-close-button' }, t('missions.closeMission')))))))));
};
